import { CustomInput } from '../../../../components/CustomInput';
import { CustomInputCurrency } from '../../../../components/CustomInputCurrency';
import { CustomSelectPicker } from '../../../../components/CustomSelectPicker';
import { Label } from '../../../../components/Label';
import { promotionsDateTypes, promotionsTypes } from '../../../../enums/promotionsTypes';
import { FaInfoCircle } from 'react-icons/fa';
import { Field, ContainerTab, Row, TabTitle, InfoBanner } from '../styles';

const RequiredTag = () => <span style={{ color: '#f00' }}>*</span>;

const listTipoPromocao = [
  { label: 'Desconto percentual', value: promotionsTypes.DESCONTO_PERCENTUAL },
  { label: 'Desconto fixo', value: promotionsTypes.DESCONTO_VALOR_FIXO },
  { label: 'Leve X pague Y', value: promotionsTypes.LEVE_X_PAGUE_Y },
  { label: 'Compre e ganhe', value: promotionsTypes.COMPRE_E_GANHE },
  { label: 'Combo preço fixo', value: promotionsTypes.COMBO_PRECO_FIXO },
  { label: 'Frete grátis', value: promotionsTypes.FRETE_GRATIS },
  { label: 'Bordas', value: 'BORDAS' },
  { label: 'Desconto por tamanho (pizza)', value: promotionsTypes.DESCONTO_TAMANHO },
];

const listTipoData = [
  { label: 'Data indeterminada', value: promotionsDateTypes.DATA_INDETERMINADA },
  { label: 'Data fixa', value: promotionsDateTypes.DATA_FIXA },
  { label: 'Data periódica', value: promotionsDateTypes.DATA_PERIODO },
];

const tipoDataHints = {
  [promotionsDateTypes.DATA_INDETERMINADA]:
    'A promoção fica válida o tempo todo enquanto estiver ativa.',
  [promotionsDateTypes.DATA_FIXA]:
    'A promoção vale apenas nos dias da semana e horários definidos na próxima etapa (ex.: toda terça das 18:00 às 23:00).',
  [promotionsDateTypes.DATA_PERIODO]:
    'A promoção vale entre uma data/hora de início e uma data/hora de término, definidas na próxima etapa.',
};

const optionStatus = [
  { value: 1, label: 'Sim' },
  { value: 0, label: 'Não' },
];

const DadosPromocao = ({
  titulo,
  setTitulo,
  descricao,
  setDescricao,
  tipoPromocao,
  setTipoPromocao,
  valor,
  setValor,
  tipoData,
  setTipoData,
  ativo,
  setAtivo,
  condicaoValorMin,
  setCondicaoValorMin,
  promocao,
}) => {
  return (
    <ContainerTab>
      <TabTitle>Dados</TabTitle>
      <Field>
        <Label>
          Título <RequiredTag />
        </Label>
        <CustomInput type="text" value={titulo} onChange={setTitulo} />
      </Field>
      <Field>
        <Label>Descrição</Label>
        <CustomInput type="text" value={descricao} onChange={setDescricao} />
      </Field>
      <Field>
        <Label>
          Tipo Promoção <RequiredTag />
        </Label>
        <CustomSelectPicker
          data={listTipoPromocao}
          style={{ width: '100%' }}
          value={tipoPromocao}
          onChange={setTipoPromocao}
          searchable={false}
        />
      </Field>
      {[
        promotionsTypes.DESCONTO_PERCENTUAL,
        promotionsTypes.DESCONTO_VALOR_FIXO,
        promotionsTypes.COMBO_PRECO_FIXO,
        promotionsTypes.LEVE_X_PAGUE_Y,
      ].includes(tipoPromocao) && (
        <Field>
          {tipoPromocao === promotionsTypes.LEVE_X_PAGUE_Y ? (
            <>
              <Label>Número de Itens Pagos</Label>
              <CustomInput
                type="number"
                min={1}
                value={+valor}
                onChange={(e) => {
                  if (+e > 0) setValor(e);
                }}
              />
            </>
          ) : (
            <>
              <Label>Valor</Label>
              <CustomInputCurrency
                percent={tipoPromocao === promotionsTypes.DESCONTO_PERCENTUAL}
                value={valor}
                onChange={setValor}
              />
            </>
          )}
        </Field>
      )}
      <Row>
        <Field>
          <Label>
            Valor mínimo do pedido <RequiredTag />
          </Label>
          <CustomInputCurrency
            value={condicaoValorMin}
            onChange={setCondicaoValorMin}
          />
        </Field>
        <Field>
          <Label>
            Tipos de datas da Promoção <RequiredTag />
          </Label>
          <CustomSelectPicker
            data={listTipoData}
            style={{ width: '100%' }}
            value={tipoData}
            onChange={setTipoData}
            searchable={false}
          />
        </Field>
      </Row>
      {tipoDataHints[tipoData] && (
        <InfoBanner>
          <FaInfoCircle size={14} />
          <span>{tipoDataHints[tipoData]}</span>
        </InfoBanner>
      )}
      {promocao && (
        <Field>
          <Label>Ativo</Label>
          <CustomSelectPicker
            data={optionStatus}
            onChange={setAtivo}
            value={ativo ? 1 : 0}
            cleanable={false}
            searchable={false}
          />
        </Field>
      )}
    </ContainerTab>
  );
};

export default DadosPromocao;
